<template>
  <div class="detail">
    <Breadcrumb separator=">">
      <BreadcrumbItem to="/help">{{$t('title.w11')}}</BreadcrumbItem>
      <BreadcrumbItem>{{$t('title.w61')}}</BreadcrumbItem>
    </Breadcrumb>
    <div class="content">
      <h3 class="h3">{{title}}</h3>
      <div v-html="content"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
     content:'',
     title:'',
     itemId:this.$route.params.id
    };
  },
  created() {
    this.init()
  },
  methods:{
    init(){
      this.$axios.get("/Member/RZJInfoCenter/HelpCenterContent", {
        params: {
          itemId:this.itemId
        }
      })
      .then(res => {
        if (res.err){
          res.throw()
          this.$router.replace({name:'help'})
          return;
        }
        this.content = res.Content;
        this.title = res.Subject;
      });
    }
  },
   watch: {
	  '$route' (to, from) { //监听路由是否变化
		  if(to.params.id != from.params.id){
        this.itemId = to.params.id;
        this.init()
		  }
	  }
  },
};
</script>

<style lang="less" scoped>
.detail {
  width: 1200px;
  min-height: 600px;
  .content {
    padding: 60px 80px;
    background: #fff;
    margin: 20px auto 0;
    color: #232325;
    /deep/ img{
      max-width: 100%;
    }
    .mar-r30 {
      margin-right: 30px;
    }
    .h3 {
      font-size: 24px;
      font-weight: 500;
      margin-bottom:40px;
    }
  }
}
</style>
